import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'
import { useAppSelector } from '../../../../../store/hooks'
import { useEffect, useState } from 'react'
import ImagePlaceholderLightSrc from './../../../../../assets/img/image-placeholder.png'
import ImagePlaceholderDarkSrc from './../../../../../assets/img/image-placeholder-dark.png'

const TemplateCard = ({ template }) => {
    const theme = useAppSelector((state) => state.theme.theme)
    const [imagPlaceholderSrc, setImagPlaceholderSrc] = useState(
        theme === 'dark' ? ImagePlaceholderDarkSrc : ImagePlaceholderLightSrc
    )

    const { id, title, short_description, features } = template

    useEffect(() => {
        setImagPlaceholderSrc(
            theme === 'dark'
                ? ImagePlaceholderDarkSrc
                : ImagePlaceholderLightSrc
        )
    }, [theme])

    return (
        <Card className="shadow mb-4">
            <Card.Img variant="top" src={imagPlaceholderSrc} />
            <Card.Body>
                <Card.Title>{title}</Card.Title>
                <Card.Text>{short_description}</Card.Text>
            </Card.Body>
            {features.length > 0 ? (
                <ListGroup className="list-group-flush">
                    {features.map((feature, index) => {
                        return (
                            <ListGroup.Item key={index}>
                                {feature}
                            </ListGroup.Item>
                        )
                    })}
                </ListGroup>
            ) : (
                <></>
            )}
            <Card.Body>
                <Card.Link href={`preview/${id}`}>Live preview</Card.Link>
                <Card.Link href="#">Choose</Card.Link>
            </Card.Body>
        </Card>
    )
}

export default TemplateCard
